import { render, staticRenderFns } from "./page21.vue?vue&type=template&id=07c1f43b&scoped=true&"
import script from "./page21.vue?vue&type=script&lang=js&"
export * from "./page21.vue?vue&type=script&lang=js&"
import style0 from "./page21.vue?vue&type=style&index=0&id=07c1f43b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1f43b",
  null
  
)

export default component.exports